const MAX_FAQS = 10;

export const getFaqs = (countryId, transFn) => {
  const faqs = [];

  for (let i = 0; i < MAX_FAQS; i += 1) {
    const titleKey = `seo.countries.${countryId}.faqs.item-${i + 1}.title`;
    const contentKey = `seo.countries.${countryId}.faqs.item-${i + 1}.answer`;

    const faqTitle = transFn(titleKey);
    const faqContent = transFn(contentKey);

    if (faqTitle !== titleKey && faqContent !== contentKey) {
      faqs.push({
        top: faqTitle,
        content: faqContent
      });
    }
  }

  return faqs;
};
